var _createClass = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _possibleConstructorReturn = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _inherits = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/inherits.js");
var _wrapNativeSuper = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});

/**
 * An error emitted by Sentry SDKs and related utilities.
 * @deprecated This class is no longer used and will be removed in a future version. Use `Error` instead.
 */
var SentryError = /*#__PURE__*/function (_Error) {
  "use strict";

  function SentryError(message) {
    var _this;
    var logLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warn';
    _classCallCheck(this, SentryError);
    _this = _callSuper(this, SentryError, [message]);
    _this.message = message;
    _this.logLevel = logLevel;
    return _this;
  }
  _inherits(SentryError, _Error);
  return _createClass(SentryError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
exports.SentryError = SentryError;